import { gql } from "@apollo/client";

const OUTGOING_STUDENTS_REQUIREMENTS = gql`
mutation updateApplicationRequirements($applicationRequirementsInput: ApplicationRequirementsInput!) {
    updateApplicationRequirements(applicationRequirementsInput: $applicationRequirementsInput) 
}
`;

export default OUTGOING_STUDENTS_REQUIREMENTS;
